<template>
<el-dialog :title="新增设变定价RFQ" :close-on-click-modal="false" width="70%" :visible.sync="viewData.visible">

        <el-tabs v-model="activeName">
            <el-tab-pane class="tab_style" :key="1" name="BasicInfo" :label="`供应商`">
                 <el-row :gutter="10">
                     <el-col :span="24">
                         <el-button style="float:right;margin-bottom: 15px;" size=mini @click="selectSupplier()">选择供应商</el-button>
                         <el-table :data="dataForm.supplierList" ref="supplierTable" :key="tableKey" size="small" :header-cell-style="{background:'#f5f5f5'}" border style="width: 100%;" :default-expand-all="false">
                             <el-table-column type="index" width="50" label="序号">
                             </el-table-column>
                             <el-table-column prop="partybCode" header-align="left" align="left" label="供应商码">
                             </el-table-column>
                             <el-table-column prop="partybRepresentive" header-align="left" align="left" label="乙方代表">
                             </el-table-column>
                             <el-table-column prop="priceAgreementCode" header-align="left" min-width="150" align="left" label="价格协议编码">
                             </el-table-column>
                             <el-table-column prop="contractStartDate" header-align="left" align="left" label="合同起始日期">
                             </el-table-column>
                             <el-table-column prop="contractEndDate" header-align="left" align="left" label="合同结束日期">
                             </el-table-column>
                             <el-table-column prop="projectName" header-align="left" align="left" label="项目名称">
                             </el-table-column>
                             <el-table-column prop="carType" header-align="left" align="left" label="车型">
                             </el-table-column>
                             <!--<el-table-column header-align="center" align="center" width="100" label="操作">
                                 <template slot-scope="scope">
                                     <el-button type="danger" size="mini" @click="deleteHandleSupplier(scope.row)" icon="el-icon-delete">
                                         删除
                                     </el-button>
                                 </template>
                             </el-table-column>-->
                         </el-table>
                     </el-col>
                 </el-row>
            </el-tab-pane>
            <el-tab-pane class="tab_style" :key="3" name="PurchaseInfo" :label="`零件列表`">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-button style="float:right;margin-bottom: 15px;" size=mini @click="selectPart()">选择零件</el-button>
                        <el-table :data="dataForm.partList" row-key="id" size="small" :header-cell-style="{background:'#f5f5f5'}" border style="width: 100%;" :default-expand-all="false">
                            <el-table-column type="index" width="50" label="序号">
                            </el-table-column>
                            <el-table-column prop="partCode" header-align="left" align="left" label="零件编号">
                            </el-table-column>
                            <el-table-column prop="partName" header-align="left" align="left" label="零件名称">
                            </el-table-column>
                            <el-table-column prop="factory" header-align="center" align="left" min-width="100" label="工厂">
                            </el-table-column>
                            <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量">
                            </el-table-column>
                            <el-table-column prop="priceWithoutTax" header-align="center" align="right" label="未税单价">
                            </el-table-column>
                            <el-table-column header-align="center" align="center" width="100" label="操作">
                                 <template slot-scope="scope">
                                     <el-button type="danger" size="mini" @click="deleteHandlePart(scope.$index)" icon="el-icon-delete">
                                         删除
                                     </el-button>
                                 </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-row :gutter="40">
                    <el-col :span="24" style="text-align:right;">
                      <el-select v-model="dataForm.subcompanyId" placeholder="请选择子公司" size="small" style="width: 150px; margin-right: 10px;">
                        <el-option
                            v-for="item in this.dataForm.supCompanyList"
                            :key="item.id"
                            :label="item.orgName"
                            :value="item.id">
                        </el-option>
                      </el-select>
                        <el-button size="small" type="primary" plain @click="saveMPQuotation()">
                            创建询价
                        </el-button>

                    </el-col>
            </el-row>
        </el-tabs>

    <!-- 弹窗, 新增 / 修改 -->
    <mp-supplier-select-dialog v-if="mpSupplierSelectDialogVisible"
                               ref="mpSupplierSelectDialog"
                               :subcompanyId="this.dataForm.subcompanyId"
                               @refreshSupplierList="getSupplierList">

    </mp-supplier-select-dialog>
    <mp-part-select-dialog v-if="mpPartSelectDialogVisible" ref="mpPartSelectDialog"  @refreshPartList="getPartList"></mp-part-select-dialog>
</el-dialog>
</template>

<script>

import {
    createMPRFQ
} from "@/controller/rfq";

import moment from 'moment'
import MpSupplierSelectDialog from "./mpsupplier-select-dialog";
import MpPartSelectDialog from "./mppart-select-dialog";
import {
    setLoading
} from "@/utils/index";
import {supCompanyList} from "../../../../controller/sys";

export default {
    components: {
        MpSupplierSelectDialog,
        MpPartSelectDialog
    },
    props: {
        vender: Object,
    },
    data() {
        return {
            loading: false,
            mpSupplierSelectDialogVisible: false,
            mpPartSelectDialogVisible: false,
            activeName: 'BasicInfo',
            viewData: {
                visible: false,
                width: ''
            },
            userInfo: '',
            dataForm: {
                id: 0,
                supplierList: [],
                partList: [],
                rfqType: '3',
                subcompanyId:'',
                supCompanyList:[]
            },
            dataRule: {},
            tableKey: ''
        }
    },
    mounted() {},
    methods: {
        init() {
            this.activeName = "BasicInfo"
            //this.userInfo = this.$store.state.user.userInfo
            this.dataForm.supplierList = []
            this.dataForm.partList = []
            this.dataForm.subcompanyId=''
            this.dataForm.supCompanyList=[]
            this.viewData.visible = true
            this.getSupCompanyList();
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        selectSupplier() {
          if (this.dataForm.supCompanyList.length == 0) {
            this.$message({
              message: '请先选择子公司再选择供应商',
              type: 'warning'
            })
            return
          }
            if (this.dataForm.supplierList.length > 0 && this.dataForm.partList.length > 0) {
                 this.$confirm(`只能选择一家供应商，重新选择供应商已选零件将被清空，是否继续操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.mpSupplierSelectDialogVisible = true;
                    this.$nextTick(() => {
                        // const _this = this
                        this.$refs.mpSupplierSelectDialog.open();
                        this.$refs.mpSupplierSelectDialog.onClosed = (payload) => {
                            if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                                this.$emit('refreshSupplierList')
                            }
                        };
                    });
                })
            } else {
                this.mpSupplierSelectDialogVisible = true;
                this.$nextTick(() => {
                    // const _this = this
                    this.$refs.mpSupplierSelectDialog.open();
                    this.$refs.mpSupplierSelectDialog.onClosed = (payload) => {
                        if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                            this.$emit('refreshSupplierList')
                        }
                    };
                });
            }

        },
        getSupplierList(val) {
            console.log("val===="+val[0])
            this.dataForm.partList = []
            this.tableKey += 1
            this.dataForm.supplierList = val
            console.log("supplierList===="+this.dataForm.supplierList[0])
        },
        selectPart() {
            if (this.dataForm.supplierList.length == 0) {
                this.$message({
                    message: '请先选择供应商再选择零件',
                    type: 'warning'
                })
                return
            }
            this.mpPartSelectDialogVisible = true;
            this.$nextTick(() => {
                // const _this = this
                this.$refs.mpPartSelectDialog.open(this.dataForm.supplierList[0].id);
                this.$refs.mpPartSelectDialog.onClosed = (payload) => {
                    if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                        this.$emit('refreshPartList')
                    }
                };
            });
        },
        getPartList(val) {
            debugger
            console.log("val===="+val);
            //this.dataForm.partList = val
            for(var item of val) {
                console.log(item);
                this.dataForm.partList.push(item)
            }
            this.dataForm.partList = Array.from(new Set(this.dataForm.partList))
        },
          getSupCompanyList(){
            supCompanyList().then(res=>{
              if(res && res.code == '00'){
                this.dataForm.supCompanyList = res.body;
                // 如果只有一条子公司数据，自动默认选中
                if (this.dataForm.supCompanyList.length === 1) {
                  this.dataForm.subcompanyId = this.dataForm.supCompanyList[0].id;
                  this.$forceUpdate();
                }
              }
            })
          },
        // 创建量产定价
        saveMPQuotation() {
            if(this.dataForm.supplierList == null || this.dataForm.supplierList.length == 0) {
                this.$message({
                    message: '请添加供应商信息',
                    type: 'warning'
                })
                return
            }
            if(this.dataForm.partList == null || this.dataForm.partList.length == 0) {
                this.$message({
                    message: '请添加零件信息',
                    type: 'warning'
                })
                return
            }
            // 创建量产询价RFQ
            let params = this.dataForm;
            this.dataFormSubmitRfq(params, "创建设变询价单成功")
        },
        // 删除供应商
        deleteHandleSupplier(row) {
            this.dataForm.supplierList = []
        },
        // 删除零件
        deleteHandlePart(x) {
            this.dataForm.partList.splice(x, 1)
        },
        dataFormSubmitRfq(params, message) {
            this.loading = true
            setLoading()
            createMPRFQ(params).then((data) => {
                if (data && data.code === "00") {
                    this.dataForm = data.body;
                    this.$message({
                        message: message,
                        type: "success",
                        onClose: () => {
                            this.viewData.visible = false;
                            this.loading = false
                            this.$emit("refreshDataList");
                        },
                    });
                    this.viewData.visible = false
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            // return 'width: 455.5px;'
        }
    }
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.button-danger {
    color: #F56C6C
}

.mb15 {
    margin-bottom: 15px;
}

.tab_style {
    min-height: 35vh;
}
</style>
